import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PermGate from "@/components/PermGate";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Catalog from "@/pages/Catalog";
import CatalogDetail from "@/pages/CatalogDetail";
import Inventory from "@/pages/Inventory";
import Leads from "@/pages/Leads";
import Bookings from "@/pages/Bookings";
import Team from "@/pages/Team";
import OrgChart from "@/pages/OrgChart";
import Roles from "@/pages/Roles";
import Quotations from "@/pages/Quotations";
import QuotationDetail from "@/pages/QuotationDetail";
import AuditLog from "@/pages/AuditLog";
import Regions from "@/pages/Regions";
import Schedule from "@/pages/Schedule";
import SchedulingSettings from "@/pages/SchedulingSettings";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route element={<PermGate module="clients" label="Clients" />}>
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
            </Route>
            <Route element={<PermGate module="catalog" label="Machine Catalog" />}>
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/catalog/:id" element={<CatalogDetail />} />
            </Route>
            <Route element={<PermGate module="inventory" label="Inventory" />}>
              <Route path="/inventory" element={<Inventory />} />
            </Route>
            <Route element={<PermGate module="leads" label="Leads" />}>
              <Route path="/leads" element={<Leads />} />
            </Route>
            <Route element={<PermGate module="bookings" label="Demo Bookings" />}>
              <Route path="/bookings" element={<Bookings />} />
              <Route path="/schedule" element={<Schedule />} />
            </Route>
            <Route element={<PermGate module="team" label="Users" />}>
              <Route path="/team" element={<Team />} />
              <Route path="/org-chart" element={<OrgChart />} />
            </Route>
            <Route element={<PermGate module="roles" label="Roles & Permissions" />}>
              <Route path="/roles" element={<Roles />} />
            </Route>
            <Route element={<PermGate module="quotations" label="Quotations" />}>
              <Route path="/quotations" element={<Quotations />} />
              <Route path="/quotations/:id" element={<QuotationDetail />} />
            </Route>
            <Route element={<PermGate module="system_admin" label="this Admin area" />}>
              <Route path="/admin/audit-log" element={<AuditLog />} />
              <Route path="/masters/regions" element={<Regions />} />
              <Route path="/masters/settings" element={<SchedulingSettings />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
